import styled from 'styled-components';
export const StyledButton = styled.button `
  background-color: #355c7e;
  border-radius: 6px;
  color: #fff;
  font-weight: 800;
  width: 100%;

  &:hover {
    background-color: #355c7e;
  }
`;
